'use strict';
define([], function() {
    function ContentController($scope) {
        function buildCategories() {
            if (!$scope.contentCategories || !$scope.content || !$scope.content.exams) {
                return;
            }
            $scope.categories = $scope.contentCategories;
      
            $scope.categoriesWithExams = {};

            for (var property in $scope.categories) {
                $scope.categoriesWithExams[property] = {
                    categoryId: property,
                    exams: []
                };
            }
                        
            for (var exam in $scope.content.exams) { 
                for (var property in $scope.categories) {
                    if ($scope.categories.hasOwnProperty(property)) {
                        if ($scope.categories[property].indexOf(exam) != -1) {
                            $scope.categoriesWithExams[property].exams.push($scope.content.exams[exam]);
                        }
                    }
                }
            }
        }

        $scope.$watch('contentCategories', buildCategories);
    }
    ContentController.$inject=['$scope'];
    return ContentController;
});

